export const TenantsIcon = ({
  size,
  stroke,
}: {
  size?: number;
  stroke?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 16}
      height={size || 16}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke || "#1D1C1C"}
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="9" cy="8" r="3"></circle>
      <path d="M3 19c0-3 2.7-5 6-5s6 2 6 5"></path>
      <path d="M16 6.4a3 3 0 010 5.7"></path>
      <path d="M17.5 14.3c2.2.5 3.5 2.1 3.5 4.2"></path>
    </svg>
  );
};
